<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpForm
    :id="formId"
    :name="formName"
    :readonly="!editing"
    class="row"
    v-if="loaded"
    @submit="evh_2248226175642056_submit($event, {})"
  >
    <ItpCol>
      <ItpFormGroup
        labelColsMd="3"
        contentColsMd="9"
        name="delivery_modes"
        :label="'Rule type'|pgettext('BillingRule')"
        :labelAlign="labelAlign"
        required
      >
        <ItpFormSelect
          name="rule_type"
          v-model="target.rule_type"
          :options="ruleTypes"
          valueField="value"
          textField="name"
          required
        >
        </ItpFormSelect>
      </ItpFormGroup>
      <BillingDateRule
        :item="target.rule"
        :metadata="metadata"
        :editing="editing"
        v-if="target.rule_type == 'billing_date'"
      >
      </BillingDateRule>
      <BillingDateRule
        :item="target.rule"
        :metadata="metadata"
        :editing="editing"
        v-if="target.rule_type == 'due_date'"
      >
      </BillingDateRule>
      <ExchangeRateDateRule
        :item="target.rule"
        :metadata="metadata"
        :editing="editing"
        v-if="target.rule_type == 'exchange_rate_date'"
      >
      </ExchangeRateDateRule>
      <ItpBox
        justifyContent="end"
      >
        <ItpButton
          :text="'Save'|pgettext('Button')"
          type="submit"
          :form="forms[formName]"
          variant="primary"
          :spinning="actions.save && actions.save.isRunning"
          :disabled="!forms[formName] || !forms[formName].submittable"
          v-if="editing"
        >
        </ItpButton>
        <ItpButton
          :text="'Cancel'|gettext"
          :disabled="!forms[formName] || !forms[formName].submittable"
          class="ml-2"
          v-if="editing"
          @click.prevent.stop="evh_6993263378944638_clickPreventStop($event, {})"
        >
        </ItpButton>
      </ItpBox>
    </ItpCol>
  </ItpForm>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BillingRule extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: Boolean,
  })
  editing!: boolean;

  @Watch('editing')
  onEditing(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("editing")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  labelAlign!: any;
  metadata!: any;

  async $$load_metadata() {
    return this.$app.repo.get('ui_metadata')
  }

  container!: any;

  async $$load_container() {
    return {
      self: this.$fn.urlFor('create_object_by_type', { object_type: 'billing-rule' }),
      object: 'list',
      data: []
    }
  }

  resource!: any;

  async $$load_resource() {
    return new this.$fn.Resource(this.item ? this.item : { rule_type: null, rule: {} })
  }

  ux!: any;
  dataMembers = ['formId', 'formName', 'labelAlign', 'metadata', 'container', 'resource', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        formName: "billingRule",
        labelAlign: "right",
        metadata: null,
        container: null,
        resource: null,
        ux: null,
      },
    }
  }

  get ruleTypes() {
    if (this.loaded) {

      return this.metadata.billing_rule_type_options
    }
    return null;
  }

  get editor() {
    if (this.loaded) {

      return this.editing ? this.resource.editor() : null
    }
    return null;
  }

  get target() {
    if (this.loaded) {

      return this.editor || this.resource
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_emit_2292_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2248226175642056_emit_2292, alias=undefined
    return {
      event: "saved",
      value: $event.data.response.data,
    }
  }

  async act_2248226175642056_rest_2290_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_2248226175642056_rest_2290, alias=save
    return {
      method: "save",
      container: this.container,
      resource: this.editor,
    }
  }

  async evh_2248226175642056_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_submit.executeFromDOM(this, event, scope);
  }

  async act_6993263378944638_script_2294_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6993263378944638_script_2294, alias=undefined
    this.$emit('cancelEdit')
  }

  async act_6993263378944638_script_2294_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6993263378944638_script_2294, alias=undefined
    return {
      value: () => this.act_6993263378944638_script_2294_getActionArgs_value($event),
    }
  }

  async evh_6993263378944638_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6993263378944638_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_2288: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_2287: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_2248226175642056_emit_2292: actions.EmitAction;
    evh_2248226175642056_saved_2291: actions.EventHandlerImpl;
    act_2248226175642056_rest_2290: actions.RestAction;
    evh_2248226175642056_submit_2289: actions.EventHandlerImpl;
    evh_2248226175642056_submit: actions.EventHandlerGroup;
    act_6993263378944638_script_2294: actions.ScriptAction;
    evh_6993263378944638_clickPreventStop_2293: actions.EventHandlerImpl;
    evh_6993263378944638_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_2288 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_2287 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_2288,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_2287],
      }
    );
    const act_2248226175642056_emit_2292 = new actions.EmitAction(
      {
        actionArgs: this.act_2248226175642056_emit_2292_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_saved_2291 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_emit_2292,
        event: "saved",
        displayName: "emit",
      }
    );
    const act_2248226175642056_rest_2290 = new actions.RestAction(
      {
        actionArgs: this.act_2248226175642056_rest_2290_getActionArgs,
        displayName: "save",
        events: [evh_2248226175642056_saved_2291],
      }
    );
    const evh_2248226175642056_submit_2289 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_rest_2290,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_2248226175642056_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_submit_2289],
      }
    );
    const act_6993263378944638_script_2294 = new actions.ScriptAction(
      {
        actionArgs: this.act_6993263378944638_script_2294_getActionArgs,
        events: [],
      }
    );
    const evh_6993263378944638_clickPreventStop_2293 = new actions.EventHandlerImpl(
      {
        action: act_6993263378944638_script_2294,
        event: "click.prevent.stop",
        displayName: "script",
      }
    );
    const evh_6993263378944638_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6993263378944638_clickPreventStop_2293],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_2288,
      evh_7315092382398562_reload_2287,
      evh_7315092382398562_reload,
      act_2248226175642056_emit_2292,
      evh_2248226175642056_saved_2291,
      act_2248226175642056_rest_2290,
      evh_2248226175642056_submit_2289,
      evh_2248226175642056_submit,
      act_6993263378944638_script_2294,
      evh_6993263378944638_clickPreventStop_2293,
      evh_6993263378944638_clickPreventStop,
      save: act_2248226175642056_rest_2290,
    }
  }
}

Vue.component("BillingRule", BillingRule);

</script>